import React from 'react';
import { Document, Packer, Paragraph, TextRun } from 'docx';

const DownloadWord = ({ text }) => {
    text = text.replace(/<br\s*\/?>/gi, '\n').replace(/<div\s*\/?>/gi, '\n').replace(/<\/div\s*\/?>/gi, '\n').replace(/&nbsp;/g, ' ');
    
    const generateWord = () => {
        const children = [];
        const lines = text.split('\n');
        lines.forEach(line => {
            let formattedText;
            if (line.startsWith('[title]')) {
                const titleText = line.replace('[title]', '').trim();
                formattedText = new TextRun({
                    text: titleText,
                    bold: true,
                    size: 24, // Size 24 corresponds to a 12-point font
                    font: "Times New Roman"
                });
            } else if (line.startsWith('[subtitle]')) {
                const subtitleText = line.replace('[subtitle]', '').trim();
                formattedText = new TextRun({
                    text: subtitleText,
                    italic: true,
                    size: 24,
                    font: "Times New Roman"
                });
            } else {
                formattedText = new TextRun({
                    text: line,
                    size: 24,
                    font: "Times New Roman"
                });
            }
            const para = new Paragraph({
                children: [formattedText],
                spacing: {
                    after: 360 // This sets the spacing after a paragraph to 1.5 lines.
                }
            });
            children.push(para);
        });

        const doc = new Document({ sections: [{ children }] });
        
        Packer.toBlob(doc).then(blob => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'document.docx';
            a.click();
        });
    };

    return <button className='content-button status-button open' onClick={generateWord}>Download as Word</button>;
};

export default DownloadWord;
